import { ENDPOINTS } from "../../constants/urls";
import { apiSlice } from "./apiSlice";

export const postEditorBlogApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createPostEditorBlog: builder.mutation({
      query: (data) => ({
        url: `${ENDPOINTS.FEATURE_EDITOR}/blog-post/`,
        method: "POST",
        body: data,
      }),
      extraOptions: { requiresAuth: true },
    }),
    generateAll: builder.mutation({
      query: (data) => ({
        url: `${ENDPOINTS.POST_EDITOR_BLOG}/generate-all/`,
        method: "POST",
        body: data,
      }),
      extraOptions: { requiresAuth: true },
    }),
    updateGenerateAll: builder.mutation({
      query: (data) => ({
        url: `${ENDPOINTS.POST_EDITOR_BLOG}/update-generate-all/${data.id}/`,
        method: "PUT",
        body: data,
      }),
      extraOptions: { requiresAuth: true },
    }),
    generateFromInstruction: builder.mutation({
      query: (data) => ({
        url: `${ENDPOINTS.POST_EDITOR_BLOG}/generate-from-instruction/`,
        method: "POST",
        body: data,
      }),
      extraOptions: { requiresAuth: true },
    }),
    getAllPostEditorBlog: builder.query({
      query: ({ website_url }) => ({
        url: `${ENDPOINTS.FEATURE_EDITOR}/blog-post/${
          website_url ? "?website_id=" + website_url : ""
        }`,
      }),
      keepUnusedDataFor: 5,
      extraOptions: { requiresAuth: true },
    }),
    getPostEditorBlog: builder.mutation({
      query: ({ id }) => ({
        url: `${ENDPOINTS.FEATURE_EDITOR}/blog-post/${id}/`,
        method: "GET",
      }),
      keepUnusedDataFor: 5,
      extraOptions: { requiresAuth: true },
    }),
    updateSinglePostEditorBlog: builder.mutation({
      query: (data) => ({
        url: `${ENDPOINTS.FEATURE_EDITOR}/blog-post/${data.id}/`,
        method: "PUT",
        body: data,
      }),
      extraOptions: { requiresAuth: true },
    }),
    linkSinglePostEditorToWebsite: builder.mutation({
      query: ({ projectId, blogPostId }) => ({
        url: `${ENDPOINTS.FEATURE_EDITOR}/blog-post/${blogPostId}/website/${projectId}`,
        method: "PUT",
      }),
      extraOptions: { requiresAuth: true },
    }),
    deleteSinglePostEditorBlog: builder.mutation({
      query: ({ id }) => ({
        url: `${ENDPOINTS.FEATURE_EDITOR}/blog-post/${id}/`,
        method: "DELETE",
      }),
      extraOptions: { requiresAuth: true },
    }),
    deleteSelectedPostEditorBlog: builder.mutation({
      query: (data) => ({
        url: `${ENDPOINTS.FEATURE_EDITOR}/blog-post/selection/`,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json", // Ensure this header is present
        },
        body: JSON.stringify(data), // Make sure the body is correctly serialized as JSON
      }),
      extraOptions: { requiresAuth: true },
    }),
    convertHtmlToDocx: builder.mutation({
      query: (data) => ({
        url: `${ENDPOINTS.DOC_MEDIA}/convert-to-docx`,
        method: "POST",
        body: data,
      }),
      extraOptions: { requiresAuth: true },
    }),
    getCompetitorAnalysis: builder.mutation({
      query: (data) => ({
        url: `${ENDPOINTS.CONTENT_ANALYSIS}/seo-analysis/`,
        method: "POST",
        body: data,
      }),
      extraOptions: { requiresAuth: true },
    }),
    getCompetitorAnalysisById: builder.mutation({
      query: ({ seo_analysis_id }) => ({
        url: `${ENDPOINTS.CONTENT_CRUD}/seo-analysis/${seo_analysis_id}`,
        method: "GET",
      }),
      extraOptions: { requiresAuth: true },
    }),
    getMoreKeywordsByAnalysisId: builder.mutation({
      query: ({ seo_analysis_id, limit }) => ({
        url: `${ENDPOINTS.CONTENT_ANALYSIS}/seo_analysis/${seo_analysis_id}/keywords/load_more?limit=${limit}`,
        method: "POST",
        body: "",
      }),
      extraOptions: { requiresAuth: true },
    }),
    reinitializeKeywordsByAnalysisId: builder.mutation({
      query: ({ seo_analysis_id }) => ({
        url: `${ENDPOINTS.CONTENT_ANALYSIS}/seo_analysis/${seo_analysis_id}/keywords/reinitialize`,
        method: "POST",
        body: "",
      }),
      extraOptions: { requiresAuth: true },
    }),
    getLinkTable: builder.mutation({
      query: (data) => ({
        url: `${ENDPOINTS.CONTENT_ANALYSIS}/link-table-analysis/`,
        method: "POST",
        body: data,
      }),
      extraOptions: { requiresAuth: true },
    }),
    getLinkTableByPageId: builder.mutation({
      query: ({ seo_analysis_id, page_id }) => ({
        url: `${ENDPOINTS.CONTENT_ANALYSIS}/seo-analysis/${seo_analysis_id}/load-link-table/${page_id}`,
        method: "POST",
        body: "",
      }),
      extraOptions: { requiresAuth: true },
    }),
    getSynonyms: builder.mutation({
      query: (data) => ({
        url: `${ENDPOINTS.CONTENT_GENERATION}/generate/synonyms/`,
        method: "POST",
        body: data,
      }),
      extraOptions: { requiresAuth: true },
    }),
    uploadImage: builder.mutation({
      query: (data) => ({
        url: `${ENDPOINTS.IMAGE_UPLOAD}`,
        method: "POST",
        body: data,
      }),
      extraOptions: { requiresAuth: true },
    }),
    getMedia: builder.mutation({
      query: () => ({
        url: `${ENDPOINTS.GET_MEDIA}`,
        method: "POST",
        body: "",
      }),
      extraOptions: { requiresAuth: true },
    }),
    deleteMedia: builder.mutation({
      query: (data) => ({
        url: `${ENDPOINTS.DELTE_MEDIA}`,
        method: "POST",
        body: data,
      }),
      extraOptions: { requiresAuth: true },
    }),
    updateMedia: builder.mutation({
      query: (data) => ({
        url: `${ENDPOINTS.UPDATE_MEDIA}`,
        method: "POST",
        body: data,
      }),
      extraOptions: { requiresAuth: true },
    }),
  }),
});
export const {
  useCreatePostEditorBlogMutation,
  useDeleteSinglePostEditorBlogMutation,
  useGenerateAllMutation,
  useGenerateFromInstructionMutation,
  useGetAllPostEditorBlogQuery,
  useGetPostEditorBlogMutation,
  useUpdateSinglePostEditorBlogMutation,
  useLinkSinglePostEditorToWebsiteMutation,
  useUpdateGenerateAllMutation,
  useDeleteSelectedPostEditorBlogMutation,
  useConvertHtmlToDocxMutation,
  useGetCompetitorAnalysisMutation,
  useGetCompetitorAnalysisByIdMutation,
  useGetMoreKeywordsByAnalysisIdMutation,
  useReinitializeKeywordsByAnalysisIdMutation,
  useGetLinkTableMutation,
  useGetLinkTableByPageIdMutation,
  useGetSynonymsMutation,
  useUploadImageMutation,
  useGetMediaMutation,
  useDeleteMediaMutation,
  useUpdateMediaMutation,
} = postEditorBlogApiSlice;
